module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/chesscom.24ff07d5.png";